module.exports = __webpack_public_path__ + "img/advance2.f6070d8a.png";